import { ReactElement } from 'react';
import { S_AnnotationStatus } from '../../../annotations/annotationStatus/S_AnnotationStatus';
import { IGroundTruth, IPointPrediction } from '../../jobPredictions.model';

interface IProps {
  predictedPoints: IPointPrediction[] | null;
  threshold: number;
  groundTruth: IGroundTruth | null | undefined;
}

export const LocatePoints = ({ predictedPoints, threshold, groundTruth }: IProps): ReactElement => {
  if (!predictedPoints) {
    return <></>;
  }

  return (
    <>
      {predictedPoints.map((predictedPoint) => {
        return (
          <div
            key={predictedPoint.classId}
            className='attributes'
          >
            <span className='attribute'>
              {predictedPoint.className}:{' '}
              <S_AnnotationStatus
                text={`${predictedPoint.points.filter((point) => point.score >= threshold).length.toString()}${groundTruth?.predictionCounts?.[predictedPoint.className] ? `/${groundTruth.predictionCounts[predictedPoint.className]}` : ''}`}
              />
            </span>
          </div>
        );
      })}
    </>
  );
};
